import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabaseClient";
import { useLeagueSeasonStore } from "@/state/useLeagueSeasonStore";
import { normalizeManagementTabCounts, type ManagementTabCounts } from "@/lib/players/licenceStateTab";

/** Clé partagée par les invalidations (handlers temps réel, routes). */
export const MANAGEMENT_TAB_COUNTS_QUERY_KEY_PREFIX = "managementTabCounts";

/** Les compteurs de l'écran Effectifs, une seule requête pour le conteneur et
 *  les deux routes : même clé, donc un seul appel réseau. Les invalidations
 *  existantes (`["managementTabCounts"]`) continuent de s'appliquer. */
export function useManagementTabCounts() {
  const season = useLeagueSeasonStore((s) => s.currentSeason);
  const leagueId = useLeagueSeasonStore((s) => s.currentLeagueId);
  return useQuery({
    queryKey: [MANAGEMENT_TAB_COUNTS_QUERY_KEY_PREFIX, leagueId, season],
    queryFn: async () => {
      // Une seule RPC pour tous les compteurs d'onglets (SECURITY DEFINER, contourne la RLS)
      const { data, error } = await supabase.rpc("get_management_tab_counts", {
        p_league_id: leagueId!,
        p_season: season!,
      });
      if (error) throw error;
      return data as unknown;
    },
    enabled: Boolean(season && leagueId),
    staleTime: 1000 * 60 * 5,
    select: (data): ManagementTabCounts => normalizeManagementTabCounts(data),
  });
}
